'use strict';

const AnnouncementAdminAPI = require('feedback/infra/api/admin/announcement');
const AnnouncementFactory = require('feedback/domain/factory/announcement/index');
const AnnouncementAdminRepository = require('feedback/domain/repository/announcement-admin');

class Service {
    constructor(json) {
        this._json = json;
    }

    create() {
        return new Promise((resolve) => {
            AnnouncementAdminAPI.create(this._json)
                .then(responseJSON => {
                    return new AnnouncementFactory().build(responseJSON);
                })
                .then(announcement => {
                    AnnouncementAdminRepository.add(announcement);
                    resolve(announcement)
                });
        });
    }
}

module.exports = Service;



// WEBPACK FOOTER //
// ./feedback/app/service/announcement/create.js